module.exports = __webpack_public_path__ + "static/media/avatar_14.82943b50.svg";